module.exports = __webpack_public_path__ + "static/media/finance.f8efcff6.png";